// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UajB","inner":"Footer_inner__1TgCT","nextIcon":"Footer_nextIcon__1DT7b","innerLeft":"Footer_innerLeft__NPXof"};